import React from 'react'
import {useLazyLoadQuery} from 'react-relay/hooks';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import Currency from '../../../components/currency/currency';
import {localCartLandImpulseQuery} from './graphql';

const Amount = ({localCartState, deferred, classes, setAmount, isStem, theme}) => {
    const request = React.useMemo(() => ({
        picks: localCartState.map((e) => ({endpoint: e.endpointId, service: e.serviceId, quantity: e.quantity}))
    }), [localCartState]);
    const {landImpulse} = useLazyLoadQuery(
        localCartLandImpulseQuery,
        {request}
    );
    React.useEffect(() => {
        if (setAmount && landImpulse && landImpulse.solves[0] && landImpulse.solves[0].amount) {
            setAmount(landImpulse.solves[0].amount);
        }
    }, [setAmount, landImpulse]);
    return (
        <span className={classNames(`${classes} display-flex`, {'opacity-0dot4 pointer-events-none' : deferred})}>
            <span className='padding-right-0dot125rem'>{landImpulse && landImpulse.solves[0] ? landImpulse.solves[0].amount : '0.00'}</span>
            <Currency {...{defaultCurrency: <FormattedMessage defaultMessage='UAH'/>, isStem, theme, stemIconClasses: 'display-block width-1dot25rem height-1dot25rem align-self-center'}}/>
        </span>
    )
}

export default React.memo(Amount);